<template>
  <button v-on:click="toggle" :title="$t(menuTitleAttr)">
    <icon :name="menuIcon"></icon>
  </button>
</template>

<script>
  export default {
    data () {
      return {
        isOpen: false,
        menuIcon: 'menu',
        menuTitleAttr: 'menu_open',
        closeFunc: (ev) => ev.keyCode === 27 && this.close()
      }
    },

    methods: {
      toggle () {
        if (this.isOpen) {
          this.close()
        } else {
          this.open()
        }
      },

      open () {
        this.isOpen = true
        this.menuIcon = 'right-angle'
        this.menuTitleAttr = 'menu_close'
        this.$emit('toggleplayermenu', true)
        document.addEventListener('keyup', this.closeFunc, { once: true })
      },

      close () {
        this.isOpen = false
        this.menuIcon = 'menu'
        this.menuTitleAttr = 'menu_open'
        this.$emit('toggleplayermenu', false)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PlayerMenuToggler.vue